import { GetDepositPromotionByIdResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getDepositPromotionById } from '../../services'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'

export default function useQueryGetDepositPromotionById(
	id: string,
	props?: UseBaseQueryOptions<GetDepositPromotionByIdResponse>,
) {
	return useQuery({
		queryKey: [DepositPromotionQueryKeys.GetDepositPromotionById, id],
		queryFn: () => getDepositPromotionById(id),
		...props,
	})
}
